import { c as R } from "./index-6e735f92.js";
var G = { exports: {} };
(function(V, W) {
  (function(k, Z) {
    V.exports = Z();
  })(R, function() {
    var k = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, Z = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, $ = /\d\d/, i = /\d\d?/, w = /\d*[^-_:/,()\s\d]+/, m = {}, E = function(t) {
      return (t = +t) + (t > 68 ? 1900 : 2e3);
    }, o = function(t) {
      return function(n) {
        this[t] = +n;
      };
    }, X = [/[+-]\d\d:?(\d\d)?|Z/, function(t) {
      (this.zone || (this.zone = {})).offset = function(n) {
        if (!n || n === "Z")
          return 0;
        var r = n.match(/([+-]|\d\d)/g), e = 60 * r[1] + (+r[2] || 0);
        return e === 0 ? 0 : r[0] === "+" ? -e : e;
      }(t);
    }], H = function(t) {
      var n = m[t];
      return n && (n.indexOf ? n : n.s.concat(n.f));
    }, _ = function(t, n) {
      var r, e = m.meridiem;
      if (e) {
        for (var f = 1; f <= 24; f += 1)
          if (t.indexOf(e(f, 0, n)) > -1) {
            r = f > 12;
            break;
          }
      } else
        r = t === (n ? "pm" : "PM");
      return r;
    }, q = { A: [w, function(t) {
      this.afternoon = _(t, !1);
    }], a: [w, function(t) {
      this.afternoon = _(t, !0);
    }], S: [/\d/, function(t) {
      this.milliseconds = 100 * +t;
    }], SS: [$, function(t) {
      this.milliseconds = 10 * +t;
    }], SSS: [/\d{3}/, function(t) {
      this.milliseconds = +t;
    }], s: [i, o("seconds")], ss: [i, o("seconds")], m: [i, o("minutes")], mm: [i, o("minutes")], H: [i, o("hours")], h: [i, o("hours")], HH: [i, o("hours")], hh: [i, o("hours")], D: [i, o("day")], DD: [$, o("day")], Do: [w, function(t) {
      var n = m.ordinal, r = t.match(/\d+/);
      if (this.day = r[0], n)
        for (var e = 1; e <= 31; e += 1)
          n(e).replace(/\[|\]/g, "") === t && (this.day = e);
    }], M: [i, o("month")], MM: [$, o("month")], MMM: [w, function(t) {
      var n = H("months"), r = (H("monthsShort") || n.map(function(e) {
        return e.slice(0, 3);
      })).indexOf(t) + 1;
      if (r < 1)
        throw new Error();
      this.month = r % 12 || r;
    }], MMMM: [w, function(t) {
      var n = H("months").indexOf(t) + 1;
      if (n < 1)
        throw new Error();
      this.month = n % 12 || n;
    }], Y: [/[+-]?\d+/, o("year")], YY: [$, function(t) {
      this.year = E(t);
    }], YYYY: [/\d{4}/, o("year")], Z: X, ZZ: X };
    function B(t) {
      var n, r;
      n = t, r = m && m.formats;
      for (var e = (t = n.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(p, l, c) {
        var s = c && c.toUpperCase();
        return l || r[c] || k[c] || r[s].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(M, Y, D) {
          return Y || D.slice(1);
        });
      })).match(Z), f = e.length, h = 0; h < f; h += 1) {
        var x = e[h], v = q[x], u = v && v[0], d = v && v[1];
        e[h] = d ? { regex: u, parser: d } : x.replace(/^\[|\]$/g, "");
      }
      return function(p) {
        for (var l = {}, c = 0, s = 0; c < f; c += 1) {
          var M = e[c];
          if (typeof M == "string")
            s += M.length;
          else {
            var Y = M.regex, D = M.parser, S = p.slice(s), g = Y.exec(S)[0];
            D.call(l, g), p = p.replace(g, "");
          }
        }
        return function(L) {
          var a = L.afternoon;
          if (a !== void 0) {
            var y = L.hours;
            a ? y < 12 && (L.hours += 12) : y === 12 && (L.hours = 0), delete L.afternoon;
          }
        }(l), l;
      };
    }
    return function(t, n, r) {
      r.p.customParseFormat = !0, t && t.parseTwoDigitYear && (E = t.parseTwoDigitYear);
      var e = n.prototype, f = e.parse;
      e.parse = function(h) {
        var x = h.date, v = h.utc, u = h.args;
        this.$u = v;
        var d = u[1];
        if (typeof d == "string") {
          var p = u[2] === !0, l = u[3] === !0, c = p || l, s = u[2];
          l && (s = u[2]), m = this.$locale(), !p && s && (m = r.Ls[s]), this.$d = function(S, g, L) {
            try {
              if (["x", "X"].indexOf(g) > -1)
                return new Date((g === "X" ? 1e3 : 1) * S);
              var a = B(g)(S), y = a.year, A = a.month, I = a.day, J = a.hours, K = a.minutes, N = a.seconds, Q = a.milliseconds, j = a.zone, O = /* @__PURE__ */ new Date(), z = I || (y || A ? 1 : O.getDate()), F = y || O.getFullYear(), T = 0;
              y && !A || (T = A > 0 ? A - 1 : O.getMonth());
              var P = J || 0, b = K || 0, C = N || 0, U = Q || 0;
              return j ? new Date(Date.UTC(F, T, z, P, b, C, U + 60 * j.offset * 1e3)) : L ? new Date(Date.UTC(F, T, z, P, b, C, U)) : new Date(F, T, z, P, b, C, U);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(x, d, v), this.init(), s && s !== !0 && (this.$L = this.locale(s).$L), c && x != this.format(d) && (this.$d = /* @__PURE__ */ new Date("")), m = {};
        } else if (d instanceof Array)
          for (var M = d.length, Y = 1; Y <= M; Y += 1) {
            u[1] = d[Y - 1];
            var D = r.apply(this, u);
            if (D.isValid()) {
              this.$d = D.$d, this.$L = D.$L, this.init();
              break;
            }
            Y === M && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          f.call(this, h);
      };
    };
  });
})(G);
const rt = G.exports;
export {
  rt as c
};
